import hyperdom from 'hyperdom'
import sum from 'root-core/utils/array/sum.js'
import formatPrice from './packages/ui-helpers/formatPrice.js'

export default class Promotions {
  constructor ({quoteCriteria, currency, modals} = {}) {
    this.quoteCriteria = quoteCriteria
    this.currency = currency
    this.modals = modals
  }

  addPromotion (promotion, showSuccessMessage) {
    const validationErrors = this.quoteCriteria.addPromotion(promotion)

    if (!validationErrors) {
      this.quoteCriteria.promotionAddedSuccessfuly = showSuccessMessage || this.quoteCriteria.promotionAddedSuccessfuly
      return
    }

    if (validationErrors.productsForPromotionNotAdded) {
      this.modals.show({
        render: () => this.renderPromoNotReadyModal({
          productsForPromotionNotAdded: validationErrors.productsForPromotionNotAdded,
          close: () => this.modals.close(),
        }),
      })
    } else if (validationErrors.promosReplacedByAutomaticPromotion) {
      this.modals.show({
        render: () => this.renderPromotionsRemovedAutomatically({
          promosReplacedByAutomaticPromotion: validationErrors.promosReplacedByAutomaticPromotion,
          close: () => this.modals.close(),
        }),
      })
    } else if (validationErrors.uncombinableProspectivePromotion) {
      this.modals.show({
        render: () => this.renderAcceptPromoModal({
          uncombinableProspectivePromotion: validationErrors.uncombinableProspectivePromotion,
          appliedPromosNotCompatibleWithNewPromotion: validationErrors.appliedPromosNotCompatibleWithNewPromotion,
          close: () => this.modals.close(),
        }),
      })
    }
  }

  renderPromoNotReadyModal ({productsForPromotionNotAdded, close}) {
    return <div class='promo-popup'>
      <div class="promo-popup__text">
        <p>You can not apply this promo until you have added {productsForPromotionNotAdded.map(p => p.name).join(' / ')}</p>
        <div class='promo-popup__button'>
          <a class='btn-promo reversed-colors' href='#' onclick={(e) => { e.preventDefault(); return close() }}>OK</a>
        </div>
      </div>
    </div>
  }

  renderAcceptPromoModal ({appliedPromosNotCompatibleWithNewPromotion, uncombinableProspectivePromotion, close}) {
    const acceptUncombinedProspectivePromotion = (e) => {
      e.preventDefault()
      this.quoteCriteria.acceptUncombinedProspectivePromotion({appliedPromosNotCompatibleWithNewPromotion, uncombinableProspectivePromotion})
      this.quoteCriteria.promotionAddedSuccessfuly = true
      close()
    }

    const clearUncombinedProspectivePromotion = (e) => {
      this.quoteCriteria.clearAdvocatePromoData(uncombinableProspectivePromotion)
      e.preventDefault()
      close()
    }

    const existingUncombinablePromos = appliedPromosNotCompatibleWithNewPromotion
    const existingUncombinablePromosAmount = sum(existingUncombinablePromos.map(p => p.amount))
    const difference = existingUncombinablePromosAmount - uncombinableProspectivePromotion.amount
    return <div class='promo-popup'>
      <div class="promo-popup__content">
        <div class="promo-popup__header">Promotion Stacking</div>
        <div class="promo-popup__text">Adding {uncombinableProspectivePromotion.name.toUpperCase()} will remove</div>
        <div class="promo-popup__list">{existingUncombinablePromos.map((promo) => (<div class="promo-popup__text">{promo.name.toUpperCase()}</div>))}</div>
        { difference === 0
          ? <div class="promo-popup__text">Both promotions are of the same value</div>
          : <div class="promo-popup__text bold">This will save you {formatPrice({amount: Math.abs(difference), currency: this.currency})} {difference > 0 ? 'less' : 'more'}</div>
        }
        <div class="promo-popup__text">Are you sure you want to add {uncombinableProspectivePromotion.name.toUpperCase()}?</div>
        <div class="promo-popup__buttons">
          <button class={`btn-promo ${difference < 0 ? 'reversed-colors' : ''}`} href='#' onclick={clearUncombinedProspectivePromotion}>No, thank you</button>
          <button class={`btn-promo ${difference < 0 ? '' : 'reversed-colors'}`} onclick={acceptUncombinedProspectivePromotion} type='button'>Yes, add</button>
        </div>
      </div>
    </div>
  }

  renderPromotionsRemovedAutomatically ({promosReplacedByAutomaticPromotion, close}) {
    return <div class='promo-popup'>
      <div class="promo-popup__text">An Air Promotion has been added that <span class='bold'>is not combinable</span> with</div>
      <div class="promo-popup__list">{promosReplacedByAutomaticPromotion.map((promo) => (<div class="promo-popup__text">{promo.name.toUpperCase()}</div>))}</div>
      <div class="promo-popup__text">{promosReplacedByAutomaticPromotion.map(p => p.name).join(', ')} will be removed from the booking</div>
      <div class='promo-popup__button'>
        <a class='btn-promo reversed-colors' href='#' onclick={(e) => { e.preventDefault(); return close() }}>OK</a>
      </div>
    </div>
  }
}